<template>
<path d="M10.5 3.5L13.5 6.5L10.5 9.5M13.25 6.5H6.5C4.567 6.5 3 8.067 3 10C3 11.933 4.567 13.5 6.5 13.5H9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
</template>
